import { render, staticRenderFns } from "./ContainerOrder.vue?vue&type=template&id=0645d9ca"
import script from "./ContainerOrder.vue?vue&type=script&lang=js"
export * from "./ContainerOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports